import { render } from "./List.vue?vue&type=template&id=1f286c9c&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=1f286c9c&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f286c9c"]])

export default __exports__